import {AiComposerDraft} from './AiComposerDraft';
import {comparePlaceholderLiterals} from './comparePlaceholderLiterals';

export const isPlaceholderSafeDraft = (
  original: AiComposerDraft,
  applied: AiComposerDraft,
  allowedAdditions: readonly string[] = []
): boolean =>
  comparePlaceholderLiterals(original.body, applied.body, allowedAdditions) &&
  comparePlaceholderLiterals(original.subject ?? '', applied.subject ?? '', allowedAdditions);
